// InventoryFilters.js - Filter bar component for Inventory page
// Note: Type/Severity/State filters moved to column headers in InventoryTable
import React, { useState, useCallback } from 'react';
import './InventoryFilters.css';

function InventoryFilters({
    filters,
    hiddenCount,
    onFilterChange,
    onSearch,
    onExport,
    onRefresh,
    loading
}) {
    const [searchInput, setSearchInput] = useState(filters.search || '');

    // Debounced search
    const handleSearchChange = useCallback((e) => {
        const value = e.target.value;
        setSearchInput(value);

        // Debounce search
        clearTimeout(window.inventorySearchTimeout);
        window.inventorySearchTimeout = setTimeout(() => {
            onSearch(value);
        }, 300);
    }, [onSearch]);

    // Handle search submit
    const handleSearchSubmit = (e) => {
        e.preventDefault();
        onSearch(searchInput);
    };

    // Clear search
    const handleClearSearch = () => {
        setSearchInput('');
        onSearch('');
    };

    return (
        <div className="inventory-filters">
            {/* Search Bar */}
            <form className="search-bar" onSubmit={handleSearchSubmit}>
                <span className="search-icon">🔍</span>
                <input
                    type="text"
                    placeholder="Search entities by key, subdomain, IP, URL..."
                    value={searchInput}
                    onChange={handleSearchChange}
                    className="search-input"
                />
                {searchInput && (
                    <button type="button" className="search-clear" onClick={handleClearSearch}>
                        ×
                    </button>
                )}
            </form>

            {/* Simplified Filter Row - Type/Severity/State moved to column headers */}
            <div className="filter-row">
                {/* Discovered Time Filter */}
                <div className="filter-group">
                    <label className="filter-label">Discovered</label>
                    <select
                        className="filter-select"
                        value={filters.newlySeen}
                        onChange={(e) => onFilterChange('newlySeen', e.target.value)}
                    >
                        <option value="">Any Time</option>
                        <option value="24h">Last 24 Hours</option>
                        <option value="7d">Last 7 Days</option>
                        <option value="30d">Last 30 Days</option>
                    </select>
                </div>

                {/* Show Suppressed Toggle */}
                <div className="filter-group filter-toggle">
                    <label className="toggle-label">
                        <input
                            type="checkbox"
                            checked={filters.hidden === 'true'}
                            onChange={(e) => onFilterChange('hidden', e.target.checked ? 'true' : 'false')}
                        />
                        <span className="toggle-text">
                            Show Suppressed {hiddenCount > 0 && `(${hiddenCount})`}
                        </span>
                    </label>
                </div>

                {/* Spacer */}
                <div className="filter-spacer"></div>

                {/* Action Buttons */}
                <div className="filter-actions">
                    <button
                        className="btn-action btn-refresh"
                        onClick={onRefresh}
                        disabled={loading}
                        title="Refresh"
                    >
                        <span className={`refresh-icon ${loading ? 'spinning' : ''}`}>↻</span>
                    </button>

                    <div className="export-dropdown">
                        <button className="btn-action btn-export" title="Export">
                            <span className="export-icon">📤</span>
                            Export
                        </button>
                        <div className="export-menu">
                            <button onClick={() => onExport('csv')}>
                                📄 Export as CSV
                            </button>
                            <button onClick={() => onExport('json')}>
                                📋 Export as JSON
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InventoryFilters;
